import {Splide} from '@splidejs/splide';
import {UpdateSplideArrows} from "../splideExtensions/updateSplideArrows";
import {SetBackgroundColorAfterBefore} from "../splideExtensions/setBackgroundColorAfterBefore";

const contentSlider = {
    init(slider) {
        const arrowPath = 'M26.0298 19.4703C26.3204 19.7609 26.3204 20.239 26.0298 20.5297L17.0298 29.5297C16.7392 29.8203 16.261 29.8203 15.9704 29.5297C15.6798 29.239 15.6798 28.7609 15.9704 28.4703L24.4407 20L15.9704 11.5297C15.6798 11.239 15.6798 10.7609 15.9704 10.4703C16.261 10.1797 16.7392 10.1797 17.0298 10.4703L26.0298 19.4703Z';

        let defaultSliderOptions = {
            type: 'loop',
            padding: '10%',
            gap: '2rem',
            rewind: false, /* Determines whether to rewind the carousel or not. */
            lazyLoad: true,
            omitEnd: true, /* disables a next arrow when a carousel reaches the last page */
            keyboard: "global",
            drag: 'free',
            snap: true,
            releaseWheel: true,
            arrowPath: arrowPath,
            perPage: 3,
            clones: 0, /* clone 0 is default and duplicate same as 4, clone 2 destroys loop functionality, clone has different side-effects */
        };

        for (let i = 0; i < slider.length; i++) {
            const pagination = slider[i].querySelectorAll('.splide__slide').length > 3;

            let splide = new Splide(slider[i], {
                ...defaultSliderOptions,
                pagination: pagination,
                breakpoints: {
                    1279: {
                        perPage: 2,
                        pagination: true,
                    },
                    767: {
                        perPage: 1,
                        pagination: true,
                        gap: '1rem',
                    },
                }
            })

            // This should destroy the carousel if there are less than x items (depends on viewport and perPage setting)
            // https://splidejs.com/guides/overflow/#loop-carousel
            splide.on("overflow", function (isOverflow) {
                // Reset the carousel position
                splide.go(0);

                splide.options = {
                    arrows: isOverflow,
                    pagination: isOverflow,
                    drag: isOverflow,
                    clones: isOverflow ? undefined : 0, // Toggle clones
                }
            })

            let splideComponents = splide.Components;
            splide.on('resized', function () {
                let isOverflow = splideComponents.Layout.isOverflow();
                let list = splideComponents.Elements.list;
                let lastSlide = splideComponents.Slides.getAt(splide.length - 1);

                if (lastSlide) {
                    // Toggles `justify-content: center`
                    list.style.justifyContent = isOverflow ? '' : 'center';

                    // Remove the last margin
                    if (!isOverflow) {
                        lastSlide.slide.style.marginRight = '';
                    }
                }
            });

            splide.mount({UpdateSplideArrows, SetBackgroundColorAfterBefore});
        }
    },
};

export {contentSlider as default};
